import { useQuery } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { ExternalIntegrationsClient, ActivationSummary } from 'api/clients/ExternalIntegrationsClient'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { integrationsKeys } from './integrationsKeys'

export const fetchActivationSummary = async ({ workspaceId }: { workspaceId: number }): Promise<ActivationSummary> => {
  const res = await ExternalIntegrationsClient.getActivationSummary({ workspaceId })
  if (res.type === 'exception' && res.data instanceof DOMException && res.data.name === 'AbortError') {
    throw res.data
  }
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    if (res.data === 'cancel') throw new DOMException('The operation was aborted.', 'AbortError')
    throw new Error(res.data as unknown as string)
  }
  return { providers: res.data }
}

export const useActivationSummary = (options?: Omit<Parameters<typeof useQuery>[2], 'queryKey' | 'queryFn'>) => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<ActivationSummary, Error>(
    integrationsKeys.activationSummary(workspaceId),
    () => fetchActivationSummary({ workspaceId }),
    {
      enabled: !!workspaceId,
      staleTime: 60_000,
      refetchOnWindowFocus: true,
      ...options,
    },
  )
}
